import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {CompanyExtensionContainerModel} from '../../../../../../models/aggregates/company';
import {Core2Config} from '../../shared/core2Config';


@Injectable({
  providedIn: 'root'
})
export class CompanyExtService extends BaseApiTemplateService<CompanyExtensionContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies-exts';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'companies-exts';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'companies-exts';
    this.httpClient = http;
  }

}
